import { FC } from 'react'
import { Helmet } from 'react-helmet'
import styles from './Drafts.module.scss'
import { useGetDraftsQuery } from 'backoffice/components/Drafts/useDraftsQuery'
import StatusFilter from 'backoffice/components/Drafts/Filters/StatusFilter'
import List from 'backoffice/components/Drafts/List'
import { Params } from 'api/fetch'
import { DraftRequestReviewStatus } from 'backoffice/components/Drafts/types/types'
import {
  ActionModalProvider,
  ConsolePetitionConfirmationModal,
} from 'backoffice/components/Drafts/Modals/ConfirmationModal'

const Drafts: FC = () => {
  const { setQueryParams, currentParams, draftsQuery } = useGetDraftsQuery({
    page: '1',
    limit: '10',
    status: DraftRequestReviewStatus.PENDING,
  })

  const handleStatusChange = (status: string | null) => {
    setQueryParams((prev) => {
      const newParams: Params = { ...prev, page: '1' }
      if (status) {
        newParams.status = status
      } else {
        delete newParams.status
      }
      return newParams
    })
  }

  return (
    <ActionModalProvider>
      <Helmet>
        <title>POAP - Console petitions</title>
        <meta property="og:title" content="POAP - Console petitions" />
      </Helmet>
      <div className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>Console petitions</h1>
        <div className={styles.filters}>
          <StatusFilter
            value={(currentParams.status as string) || null}
            onChange={handleStatusChange}
            className={styles.statusFilter}
          />
        </div>
      </div>
      <List draftsQuery={draftsQuery} setQueryParams={setQueryParams} />
      <ConsolePetitionConfirmationModal />
    </ActionModalProvider>
  )
}

export { Drafts }
